"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = require("styled-components");
var ecosystem_lib_brand_styles_1 = require("@agco-onedigital/ecosystem-lib-brand-styles");
var mediaQueries_1 = require("../../utils/mediaQueries");
var Sidebar_1 = require("../Sidebar");
var ThemeProvider = function (_a) {
    var children = _a.children, brand = _a.brand, _b = _a.baseUrl, baseUrl = _b === void 0 ? '' : _b;
    var brandTheme = (0, ecosystem_lib_brand_styles_1.getTheme)(brand);
    var isSidebarOpen = (0, Sidebar_1.useSidebarState)().isSidebarOpen;
    var theme = __assign(__assign(__assign({}, brandTheme), (0, mediaQueries_1.getMediaQueries)(isSidebarOpen)), { baseUrl: baseUrl });
    return (0, jsx_runtime_1.jsx)(styled_components_1.ThemeProvider, __assign({ theme: theme }, { children: children }));
};
exports.default = ThemeProvider;
